module.exports = __webpack_public_path__ + "static/media/onboarding-navigation.505658de.gif";